export enum DigitalTrapFilterType {
  TEXT_SEARCH = 'text_search',
  CURRENT_DATE = 'current_date'
}

export type FilterContext = 'Daily Counts' | 'Network Management';
